/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Skill_S3Inputs */

const en_mk_tut_skill_s3 = /** @type {(inputs: Mk_Tut_Skill_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attach the Skill to the relevant agents. One Skill can serve many agents at once.`)
};

const id_mk_tut_skill_s3 = /** @type {(inputs: Mk_Tut_Skill_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasang Skill itu ke agen yang relevan. Satu Skill boleh dipakai banyak agen sekaligus.`)
};

/**
* | output |
* | --- |
* | "Attach the Skill to the relevant agents. One Skill can serve many agents at once." |
*
* @param {Mk_Tut_Skill_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_skill_s3 = /** @type {((inputs?: Mk_Tut_Skill_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Skill_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_skill_s3(inputs)
	return en_mk_tut_skill_s3(inputs)
});